import { EndpointRequest } from "../_system/EndpointRequest";
import {
  SettingsRequestDto as RequestDto,
  SettingsResponseDto as ResponseDto,
} from "../api/settings/dtos";
import { Api } from "../api";
import { Currency } from "dinero.js";

interface Data {
  contact_url: string | null;
  facebook: string | null;
  instagram: string | null;
  twitter: string | null;
  linkedin: string | null;
  website_url: string | null;
  privacy_policy_url: string | null;
  terms_and_conditions_url: string | null;
  phone: string | null;
  email: string | null;
  logo: string | null;
  primary_color: string | null;
  background_image: string | null;
  custom_js_code: string | null;
  proclaimer_url: string | null;
  default_language: string | null;
  currency: Currency;
  payment_rules: string[];
  seo: {
    title?: string | null;
    keywords?: string | null;
    description?: string | null;
  };
  important_announcement_title: string | null;
  important_announcement_text: string | null;
  description_supplement_menu: string | null;
}
export const SettingsEndpoint = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data
>("APP_SETTINGS", Api.settings, ({ data: { data } }) => {
  return {
    contact_url: data.contact_url,
    facebook: data.facebook,
    instagram: data.instagram,
    twitter: data.twitter,
    linkedin: data.linkedin,
    website_url: data.website_url,
    privacy_policy_url: data.privacy_policy_url,
    terms_and_conditions_url: data.terms_and_conditions_url,
    phone: data.phone,
    email: data.email,
    logo: data.logo,
    primary_color: data.primary_color,
    background_image: data.background_image,
    custom_js_code: data.custom_js_code,
    proclaimer_url: data.proclaimer_url,
    default_language: data.default_language,
    currency: data.currency,
    payment_rules: data.payment_rules,
    seo: {
      title: data.seo_title,
      keywords: data.seo_keywords,
      description: data.seo_description,
    },
    important_announcement_title: data.important_announcement_title,
    important_announcement_text: data.important_announcement_text,
    description_supplement_menu: data.description_supplement_menu,
  };
});
